<template>
    <GMapMap
        :center="center"
        :zoom="6.8"
        ref="myMapRef"
        map-type-id="terrain"
        :options="options"
        style="width: 100%; height: 40vw"
    >
        <GMapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :draggable="true"
        @click="openMarker(m.id)" >
            <GMapInfoWindow
            :closeclick="true"
            @closeclick="openMarker(null)"
            :opened="openedMarkerID === m.id"
            :options="{
                pixelOffset: {
                    width: 10, height: 0
                },
                maxWidth: 320,
                maxHeight: 320,
            }"
            >
            <div>Proyecto UUID: <a :href="'/control/projects/' + m.id">{{ m.id }}</a> </div>
            </GMapInfoWindow>
        </GMapMarker>
    </GMapMap>
</template>

<script >
export default {
    name: 'App',
    mounted() {
        this.markers = [];

        this.$refs.myMapRef.$mapPromise.then((mapObject) => {
          console.log('map is loaded now', mapObject);

          axios
          .get('/api/v1/projects')
          .then(response => (this.setProjects(response.data.data)));
        });
    },
    methods: {
        openMarker(id) {
            this.openedMarkerID = id
        },
        setProjects(projects) {
            this.projects = projects;

            this.projects.forEach(this.myFunction);
        },
        myFunction(item, index) {
            this.markers.push({
                id: item.uuid,
                position: {
                    lat: parseFloat(item.location_lat),
                    lng: parseFloat(item.location_lng)
                }
            });
        }
    },
    data() {
        return {
            openedMarkerID: null,
            center: {
                lat: 8.561406, //10.4806,
                lng: -66.021978 //-66.9036
            },
            markers: this.markers,
            options: {
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: true,
                fullscreenControl: true,
                styles: [
                    {
                        "featureType": "administrative",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.country",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "weight": 4
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    }
                ],
            },
        }
    }
}
</script>
